module.exports = __webpack_public_path__ + "static/media/reasons-why.5dd9b4ce.jpg";